import { Tooltip2 } from '@blueprintjs/popover2'
import React from 'react'
import { getLinkedinV2 } from '../../Functions/AIFunctions/LinkedinOutreach'
import { TemplateModel } from '../../Functions/AIFunctions/NewJuneModels/TemplateModel'
import { getShortestModel } from '../../Functions/AIFunctions/ShortestModel'
import { getIntro } from '../../Functions/AIFunctions/ShortIntro'
import GenerateHK from '../../Functions/Hotkeys/GenerateHK'


function GenerateButton({
    shownButton,
    profile, 
    fbProfile, 
    vProp,
    intVal, 
    auth, 
    setContentGen, 
    setGenerating, 
    tokens, 
    docId, 
    LIurl, 
    interests, 
    foundInts,
    interestValues,
    setBtnClicked,
    setShowTooltip,
    callToAction,
    setEditing,
    generating,
    showBtn,
    teamToken,
    tokensTeam,
    oneLinerModel,
    actionInitModel,
    probingModel
}) {
// console.log(oneLinerModel)
    return (
        <div>
        <Tooltip2
        content={tokens?.totalTokens === 0 || ((teamToken?.[0]?.teamToken && tokensTeam < 1)) ? "Buy More Tokens To Generate A Message" : "Select a Topic and a Value Prop"}
        placement="left"
        isOpen={(tokens?.totalTokens === 0 || intVal === "" || vProp === "" || vProp === undefined) ? true : false}
        >
        {shownButton === "Short Intro" ?
        // This is where to do if context type, where it ends is commented below
        (vProp?.ContextType === 'template' ?
        <div>
            <button
            className="mr-0 text-base h-8 mt-2 bg-green-600 border-2 border-green-600 hover:bg-green-800 focus:bg-blue-800 text-white font-semibold px-4 rounded focus:outline-none focus:ring focus:border-indigo-300 disabled:opacity-50 animate-pulse"
            onClick={() => TemplateModel(
                profile, 
                fbProfile, 
                vProp, 
                intVal, 
                auth, 
                setContentGen, 
                setGenerating, 
                tokens, 
                docId, 
                LIurl, 
                interests, 
                foundInts, 
                setShowTooltip, 
                callToAction, 
            )}
            disabled={showBtn}
            >
                Create
            </button>
        </div>
        :
        <div>
        <button
        className="mr-0 text-base h-8 mt-2 bg-green-600 border-2 border-green-600 hover:bg-green-800 focus:bg-blue-800 text-white font-semibold px-4 rounded focus:outline-none focus:ring focus:border-indigo-300 disabled:opacity-50 animate-pulse"
        onClick={() => getIntro(
            profile, 
            fbProfile, 
            vProp,
            intVal, 
            auth, 
            setContentGen, 
            setGenerating, 
            tokens, 
            docId, 
            LIurl, 
            interests, 
            foundInts,
            interestValues,
            setBtnClicked,
            setShowTooltip,
            callToAction,
            setEditing,
            teamToken,
            tokensTeam,
            oneLinerModel,
            actionInitModel,
            probingModel
        )}
        disabled={showBtn}
        >
            Create
        </button>
        {showBtn !== true ? 
        <GenerateHK 
        generate={() => getIntro(
            profile, 
            fbProfile, 
            vProp,
            intVal, 
            auth, 
            setContentGen, 
            setGenerating, 
            tokens, 
            docId, 
            LIurl, 
            interests, 
            foundInts,
            interestValues,
            setBtnClicked,
            setShowTooltip,
            callToAction,
            setEditing,
            teamToken,
            tokensTeam,
            oneLinerModel,
            actionInitModel,
            probingModel

        )}
        />
        :
        null }
        </div>
        )
        // this is where it ends for the short intro
        :
        (shownButton === "LinkedIn" ?
        <div>
        <button
        className="mr-4 mb-2 text-base h-10 mt-2 bg-blue-600 border-2 border-blue-400 hover:bg-indigo-300 focus:bg-green-500 text-white font-semibold px-4 rounded focus:outline-none focus:ring focus:border-indigo-300 disabled:opacity-50 animate-pulse"
        disabled={showBtn}
        onClick={() => getLinkedinV2(
            profile, 
            fbProfile, 
            vProp,
            intVal, 
            auth, 
            setContentGen, 
            setGenerating, 
            tokens, 
            docId, 
            LIurl, 
            interests, 
            foundInts,
            interestValues,
            setBtnClicked,
            callToAction,
            setEditing 
        )}
        >
            Create Linkedin
        </button>
        {showBtn !== true ?
        <GenerateHK 
        generate={() => getLinkedinV2(
            profile, 
            fbProfile, 
            vProp,
            intVal, 
            auth, 
            setContentGen, 
            setGenerating, 
            tokens, 
            docId, 
            LIurl, 
            interests, 
            foundInts,
            interestValues,
            setBtnClicked,
            callToAction,
            setEditing 
        )}
        />
        : null }
        </div>
        :
        (shownButton === "ShortestModel" ?
        <div>
        <button
        className="mr-4 mb-2 text-base h-10 mt-2 bg-blue-600 border-2 border-blue-400 hover:bg-indigo-300 focus:bg-green-500 text-white font-semibold px-4 rounded focus:outline-none focus:ring focus:border-indigo-300 disabled:opacity-50 animate-pulse"
        disabled={showBtn}
        onClick={() => getShortestModel(
            profile, 
            fbProfile, 
            vProp,
            intVal, 
            auth, 
            setContentGen, 
            setGenerating, 
            tokens, 
            docId, 
            LIurl, 
            interests, 
            foundInts,
            interestValues,
            setBtnClicked,
            setShowTooltip,
            callToAction,
            setEditing 
        )}
        >
            Create Brief
        </button>
        {showBtn !== true ?
        <GenerateHK 
        generate={() => getShortestModel(
            profile, 
            fbProfile, 
            vProp,
            intVal, 
            auth, 
            setContentGen, 
            setGenerating, 
            tokens, 
            docId, 
            LIurl, 
            interests, 
            foundInts,
            interestValues,
            setBtnClicked,
            setShowTooltip,
            callToAction,
            setEditing 
        )}
        />
        : null }
        </div>
        :
        null
        )
        )
        }
        </Tooltip2>
        </div>
    )
}

export default GenerateButton
